import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const VportSplitVicon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 20"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23 0H1C0.4 0 0 0.4 0 1V19C0 19.6 0.4 20 1 20H23C23.6 20 24 19.6 24 19V1C24 0.4 23.6 0 23 0ZM2 2H11V18H2V2ZM22 18H13V2H22V18Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

VportSplitVicon.displayName = 'VportSplitVicon';
